import { IconType } from "react-icons"

export interface item  {
  id: string
  icon: IconType
  text: string
  role: Array<string>
}

export const defaultList: Array<item> = [];